// Vermittlung zwischen dem fetch-Wrapper (ausserhalb von React) und dem
// Reauth-Dialog (innerhalb von React) — QA-Befund S-1.
//
// Frueher fuehrte jeder 401 zu window.location.replace('/login'). Damit war
// jeder ungespeicherte Formularinhalt weg, teils ohne dass im betroffenen
// Tab ueberhaupt jemand etwas getan hatte. Stattdessen fragt der
// fetch-Wrapper hier nach einer neuen Anmeldung und wiederholt die Anfrage
// danach — der React-State bleibt unangetastet.

type ReauthHandler = () => Promise<boolean>;

let handler: ReauthHandler | null = null;
let laufend: Promise<boolean> | null = null;

// Hatte dieser Tab jemals eine gueltige Sitzung?
//
// Der Dialog gehoert ausschliesslich zum Sitzungstod mitten in der
// Arbeit. Beim Erstbesuch ohne Anmeldung waere er sinnlos bis
// irrefuehrend — welche Sitzung soll abgelaufen sein, welche Eingaben
// sollen erhalten bleiben? Dort gehoert schlicht die Login-Seite hin.
//
// Ohne diese Unterscheidung genuegte ein 401 einer beliebigen
// Datenabfrage, um den Dialog ueber die Login-Seite zu legen: die
// geschuetzte Route laedt ihre Daten, bevor die Umleitung greift.
let hatteSitzung = false;

/** Wird aufgerufen, sobald eine gueltige Anmeldung feststeht. */
export function merkeSitzungBestand(): void {
  hatteSitzung = true;
}

/** Der Dialog meldet sich hier an. Rueckgabe entfernt die Registrierung. */
export function registriereReauthHandler(fn: ReauthHandler): () => void {
  handler = fn;
  return () => {
    if (handler === fn) handler = null;
  };
}

/**
 * Fordert eine neue Anmeldung an. Parallele 401er teilen sich denselben
 * Dialog — sonst stapeln sich bei mehreren gleichzeitigen Requests
 * mehrere Anmeldeaufforderungen.
 *
 * Liefert true, wenn wieder eine gueltige Sitzung besteht.
 */
export function verlangeReauth(): Promise<boolean> {
  // Erstbesuch ohne Anmeldung: kein Dialog. Der 401 bleibt ein normaler
  // Fehler, und die Shell leitet auf die Login-Seite um.
  if (!hatteSitzung) return Promise.resolve(false);
  if (handler === null) return Promise.resolve(false);
  if (laufend === null) {
    laufend = handler().finally(() => {
      laufend = null;
    });
  }
  return laufend;
}

export function reauthLaeuft(): boolean {
  return laufend !== null;
}
